import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// The Find tab is currently the existing Investor Matching platform at /investors.
// A thin redirect keeps the URL contract stable if we later split them.
export default function FundraisingFind() {
  const navigate = useNavigate();
  useEffect(() => { navigate("/investors", { replace: true }); }, [navigate]);
  return null;
}
